export type TravelDocument = {
  id: number;
  fileUrl: string;
  fileKey: string;
  contentType: string;
  displayName: string;
  signerType: SignerType;
};

export enum SignerType {
  OnSigner = "OnSigner",
  OffSigner = "OffSigner",
}

export const SignerTypeLabel: { [key in SignerType]: string } = {
  [SignerType.OffSigner]: "Offsigner",
  [SignerType.OnSigner]: "Onsigner",
};

export enum TravelDocumentOperationType {
  LOAD = "LOAD",
  UPLOAD = "UPLOAD",
  DOWNLOAD = "DOWNLOAD",
  DELETE = "DELETE",
}
